"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  userAndPermission: {
    shoreOrVessel: '船岸端',
    resetSuccess: '重置成功',
    resetAllUsersBlock: '重置所有用户区块',
    resetSelectedUserBlock: '重置选择用户区块',
    chooseBlock: '选择区块',
    userPermission: '用户与权限',
    accountMaintenance: '账号管理',
    userCode: '账号编码',
    loginName: '登录名',
    personMsg: '人员信息',
    organization: '所属组织',
    roleName: '兼任角色',
    navigationMenu: '导航菜单',
    pleaseSelectOrg: '请选择组织...',
    pleaseEnter: '请输入内容',
    pleaseSelect: '请选择',
    pleaseSelectDate: '请选择日期',
    selectDate: '选择日期',
    responsibleShip: '负责船舶',
    nameCn: '中文姓名',
    operId: '日志ID',
    logTitle: '操作模块',
    businessType: '业务类型',
    businessTypes: '业务类型数组',
    method: '请求方法',
    requestMethod: '请求方式',
    operatorType: '操作类别',
    operName: '操作人员',
    deptName: '部门名称',
    operUrl: '请求URL',
    operIp: '操作地址',
    operLocation: '操作地点',
    operParam: '请求参数',
    jsonResult: '返回参数',
    status: '操作状态',
    errorMsg: '错误消息',
    operTime: '操作时间',
    nameEn: '英文姓名',
    jobNumber: '工号',
    leaderUserName: '汇报对象',
    defaultRoleName: '角色',
    manageWorkType: '管理工作',
    reservedStr1: '公共角色',
    reservedStr2: '扩展字段2',
    reservedStr3: '扩展字段3',
    reservedStr4: '扩展字段4',
    reservedStr5: '扩展字段5',
    commonRole: '公共角色',
    validFlag: '是否注销',
    valid: '有效',
    invalid: '无效',
    invalidDate: '注销日期',
    additional: '兼任',
    isJobFlagShow: '角色类别',
    companyName: '兼任公司',
    companyRoleName: '兼任公司岗位',
    certNumber: '证件号',
    jobRole: '岗位角色',
    postRole: '非岗位角色',
    accountCode: '账号代码',
    userNameCn: '账号名称',
    userNameEn: '账号名称(EN)',
    defaultOfficeName: '默认组织',
    defaultRole: '默认角色',
    sex: '性别',
    logoutStatus: '注销状态',
    officePhone: '办公电话',
    email: '电子邮箱',
    index: '序号',
    deptManager: '部门管理者',
    validStatus: '注销状态',
    operation: '操作',
    documentType: '证件类型',
    phoneNumber: '手机号码',
    fax: '传真',
    wechat: '微信号',
    qqNumber: 'QQ号',
    nativePlace: '籍贯',
    maritalStatus: '婚姻状况',
    entryTime: '入司时间',
    graduationYear: '毕业年份',
    remark: '备注',
    creator: '创建人',
    createTime: '创建时间',
    updateUser: '更新人',
    seqNo: '显示顺序',
    isHsqeFlag: '是否体系内',
    updateDate: '更新时间',
    addAccount: '新增账号',
    man: '男',
    woman: '女',
    false: '否',
    true: '是',
    certTypeEmpty: '证件类型不能为空',
    certNumberEmpty: '证件号不能为空',
    notCancelled: '未注销',
    cancelled: '已注销',
    married: '已婚',
    unmarried: '未婚',
    mainlandIdCard: '大陆居民身份证',
    HKIdCard: '香港居民身份证',
    Fujian: '福建',
    Beijing: '北京',
    orgCode: '组织机构代码',
    orgName: '组织机构名称',
    parentOrgCode: '上级组织机构代码',
    parentOrgName: '上级组织机构名称',
    orgType: '组织机构类型',
    officeCode: '公司代码',
    officeName: '公司名称',
    departmentCode: '部门代码',
    departmentName: '部门名称',
    roleCode: '角色代码',
    characterName: '角色名称',
    characterNameEn: '角色名称(英文)',
    parentRoleCode: '上级角色代码',
    parentRoleName: '上级角色名称',
    employeeNo: '员工号',
    inputJobNumber: '请输入工号',
    between50: '长度在 1 到 50 个字符',
    inputNameCn: '请输入中文姓名',
    inputNameEn: '请输入英文姓名',
    between100: '长度在 1 到 100 个字符',
    between500: '长度在 1 到 500 个字符',
    selectOrg: '请选择所属组织',
    selectLoginID: '请输入登录账号',
    selectSex: '请选择性别',
    selectRole: '请选择角色',
    addUserMsg: '人员信息新增',
    editUserMsg: '人员信息编辑',
    group: '集团',
    company: '公司',
    dept: '部门',
    errMsg: '请求数据失败，请稍后再试',
    selectOrgUser: '请选择要迁移组织的人员',
    selectTransferorg: '请选择所要迁移的组织',
    selectOrganizationNo: '请选择要迁移组织的账号',
    transferSuccess: '迁移成功',
    selectDeleteNo: '请选择要删除的账号',
    selectHolidayCrew: '请选择一名公休船员',
    confirm: '确定',
    cancel: '取消',
    addSuccess: '新增成功',
    editSuccess: '编辑成功',
    selectDelUser: '请选择要删除的人员',
    delRecord: '是否确认删除该记录',
    selsectStartTime: '请选择开始时间',
    addLessAccount: '请至少添加一条记录',
    delSuccess: '删除成功',
    changeTimeSuccessfully: '更改时间成功',
    selsectLogout: '请选择需要更改时间的记录',
    cancelCancellationUser: '请选择要取消注销的人员',
    cancelCancellationSuccess: '取消注销成功',
    cancellationUser: '请选择要注销的人员',
    cancellationNo: '请选择要取消注销的账号',
    selectcancellationNo: '请选择要注销的账号',
    cancellationSuccess: '注销成功',
    selectMostAccount: '请选择至多一个账号',
    hints: '请选择一条记录',
    selectMostShip: '请选择勾选至少一条船舶',
    selectDeleteShip: '请选择要删除的船舶',
    accountNumber: '账号【',
    passwordResetSuccessfully: '】重置密码成功，初始密码为【',
    message1: '角色类别、兼任角色不可为空',
    message2: '兼任公司不可为空',
    message3: '所属组织不可为空',
    saveSuccessfully: '保存成功',
    message4: '请先保存账号',
    message5: '请选择要删除的记录',
    message6: '是否确认删除该记录',
    errorTimes: '错误次数',
    hint: '提示',
    resetPassword: '重置密码',
    startTime: '开始时间',
    endTime: '结束时间',
    changeTime: '更改时间',
    vesselTeamName: '船队名称',
    vesselName: '船舶名称',
    beginDate: '管理开始时间',
    endDate: '管理结束时间',
    boatTrain: '船队',
    shipping: '船舶',
    management: '后台管理',
    vesselCode: '船舶代码',
    refresh: '刷新',
    accordingCancellation: '显示注销',
    fastSearch: '快速搜索',
    all: '全部',
    sort: '排序',
    order: '顺序',
    systemManagement: '系统管理',
    configurationMenu: '菜单配置',
    addNode: '添加主节点',
    shrink: '收缩',
    unfold: '展开',
    detailedInformation: '详细信息',
    type: '类型 (pathType)',
    routingAddress: '路由地址 (path)',
    redirect: '重定向地址 (redirect)',
    eg: '如，/',
    egDashboard: '如，/dashboard',
    componentAddress: '页面组件地址 (component)',
    routName: '路由名称 (name)',
    suchIndex: '比如，index',
    title: '标题 (title)',
    titleCn: '中文标题 (chinese title)',
    titleEn: '英文标题 (english title)',
    selectTitle: '请输入标题',
    selectCnTitle: '请输入中文标题',
    selectEnTitle: '请输入英文标题',
    icon: '图标 (icon)',
    pathSeq: '顺序 (pathSeq)',
    suchDashboard: '比如，dashboard',
    selectOrder: '请输入顺序',
    alwaysShow: '一直显示根路由 (alwaysShow)',
    hidden: '隐藏该项菜单 (hidden)',
    activeMenu: '高亮菜单路由 (activeMenu)',
    dashboardOptional: '如，/dashboard，选填',
    noCache: '不缓存 (noCache)',
    applyCompanys: '适用公司',
    selectCompany: '请选择公司',
    btnTitle: '按钮标题 (title)',
    btnPath: '按钮权限地址 (path)',
    btnName: '按钮名称 (name)',
    component: '组件地址 (component)',
    menuConfigurationInstructions: '菜单配置说明',
    pathTypeInstructions: "可选类型(MENU:菜单，可展示的页面；BUTTON:按钮，配置在具体菜单下，选择该项可配置参数会相应改变；SYSTEM:系统，最高级一层，通常配置时不选此项；MODULE:模块，通常时顶部导航，配置组件为'layout'；GROUP:组，二级路由，包含MENU，需要组件内配置'router-view')，给子菜单显示",
    pathInstructions: "填写绝对地址，子路由需包含父级地址，比如父级为‘/manage’，则子菜单为'/manage/user',三级路由'/manage/user/list'，以此类推",
    redirectInstructions: '重定向地址，访问该路由时，重新跳转新地址',
    componentInstructions: "组件路径，默认都为view 文件夹下路径，配置时省略（'view'）,比如'/manage/userAndPermission/featureMange'",
    strongInstructions: "需注意前端代码在'utils/page.js',添加组件信息后，才可做选择",
    nameInstructions: "例如'featureManage',首字母大写",
    iconInstructions: '根据阿里图标提供的icon',
    titleInstructions: ' 选择标题，跟国际化i18n 有关',
    titleStrongInstructions: '需在lang文件夹下，配置router标题',
    edit: '新增',
    update: '更新',
    menu: '菜单',
    button: '按钮',
    system: '系统',
    module: '模块',
    groups: '组',
    selectType: '请选择类型',
    enterRouting: '请输入路由',
    componentsNotEmpty: '组件不能为空',
    routerNotEmpty: '路由名称不能为空',
    titleNotEmpty: '标题不能为空',
    orderNotEmpty: '顺序不能为空',
    selectDeleteMenu: '请选择要删除的菜单',
    isDeleteRecord: '非配置人员谨慎操作。您确定要删除该记录吗？',
    functionalAuthority: '功能权限',
    urlTitleShow: '权限标题',
    url: '权限地址',
    urlType: '权限类型',
    urlSeq: '地址顺序',
    boName: '业务对象名',
    methodName: '方法名',
    tableName: '表名',
    columnName: '字段名',
    refreshAllCache: '刷新所有缓存',
    refreshSuccess: '刷新成功',
    desc: '描述',
    operatorValue: '操作符',
    generateScript: '生成脚本',
    conditionValue: '条件值',
    urlParamList: '参数列表',
    rolePermission: '角色权限',
    personnel: '人员',
    parentResourceName: '上级权限',
    urlLevel: '地址层次',
    menuNotEmpty: 'MENU表名不能为空',
    newPermissions: '功能权限新增',
    permissionEditing: '功能权限编辑',
    urlTitle: '标题',
    location: '地址',
    enterPermissionTitle: '请输入权限标题',
    enterPermissionAddress: '请输入权限地址',
    configurationManagement: '数据权限配置管理',
    conditionSql: '条件SQL',
    crudType: '操作类型',
    pleaseInput: '请输入...',
    explain: '说明',
    loginAccountName: '当前登录账号名',
    loginAccountBelongs: '当前登录账号所属组织',
    selectOrganizationAccount: '请选择角色',
    selectTable: '请选择表名',
    selectRoleAccount: '请选择角色',
    selectChildNode: '请选择子节点',
    conditionSqlNotNull: '条件SQL不能为空',
    pleaseSaveFirst: '数据未保存，请先保存',
    SelectDataDelete: '请选择要删除的数据',
    roleMaintaining: '角色维护',
    parentRole: '上级角色',
    officeChiefFlag: '部门正职',
    VirtualRole: '虚拟角色',
    VirtualRoleYes: '是',
    VirtualRoleNo: '否',
    effDate: '有效期从',
    expDate: '有效期到',
    loseEfficacy: '失效',
    operatingAuthorization: '操作权限',
    authorizationsPrivileges: '授权权限',
    bankAccountNo: '账号',
    temporalComparison: '结束时间不能小于开始时间',
    selectOrganization: '请选择上级组织',
    selectCategory: '请选择角色类别',
    enterRoleName: '请输角色名称',
    between200: '长度在 1 到 200 个字符',
    enterEnglishName: '请输角色英文名称',
    maintainedCurrentPage: '组织节点无法在当前页面维护',
    companiesDepartmentsNotEmpty: '公司、部门均不可为空',
    updateSuccessfully: '更新成功',
    selectAccountNo: '请选择账号',
    deleteAccountNo: '请选择要删除的账号信息',
    isFlagAllSelected: '是否拥有权限角色',
    defaultRoleFlag: '是否默认角色',
    defaultRoleFlagMsg1: '当前账号的角色为默认角色，不能删除！',
    defaultRoleFlagMsg2: '所选账号中，有账号的角色为默认角色，请核查后删除！',
    authorizedApproval: '授权审批',
    authorizer: '授权人',
    beiAuthorizer: '被授权人',
    authorizationTime: '授权开始时间',
    authorizationEndTime: '授权结束时间',
    authorizationTerminationTime: '终止时间',
    quantityProcessed: '授权已办数',
    addAuthorizeMsg: '授权审批信息新增',
    editAuthorizeMsg: '授权审批信息编辑',
    authorizerCompany: '授权人公司',
    authorizationRole: '授权角色',
    authorizationType: '授权类型',
    messageNotification: '消息提醒',
    emailAlert: '邮件提醒',
    save: '保存',
    selectResetMsg: "请选择重置用户账号"
  }
};